import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { API_CLIENT_SERVICE_IMPL, FilteredPageQuery, IAPIClientService } from 'shared';
import { IProductProviderService } from './iproductprovider-service';
import { ProductLocationMap } from 'dm-src/dtos/product-location-map';
import { HttpResponse } from '@angular/common/http';

@Injectable()
// @Injectable({ providedIn: 'root' })
export class ProductProviderService implements IProductProviderService {
    constructor(@Inject(API_CLIENT_SERVICE_IMPL) private _apiClient: IAPIClientService) {}

    public getShelfDisplayNameKeys(orderid: number): Observable<any> {
        return this._apiClient.getWithResponse<ProductLocationMap[]>(
            `productprovider/get-shelf-display-name-key/${orderid}`
        );
    }

    public getShelfPositionDisplayNameKeys(
        productproviderid: number,
        orderid: number
    ): Observable<any> {
        return this._apiClient.getWithResponse<string[]>(
            `productprovider/get-shelf-position-display-name-key/${productproviderid}/${orderid}`
        );
    }

    public setProductLocationMap(
        productproviderid: number,
        productlocationmapid: string,
        orderid: number
    ): Observable<HttpResponse<ProductLocationMap>> {
        return this._apiClient.postWithResponse<ProductLocationMap>(
            `productprovider/set-product-location-map`,
            { productproviderid, productlocationmapid, orderid }
        );
    }

    public setShelfPositionDisplayNameKey(
        productproviderid: number,
        shelfpositiondisplaynamekey: string,
        orderid: number
    ): Observable<HttpResponse<ProductLocationMap>> {
        return this._apiClient.postWithResponse<ProductLocationMap>(
            `productprovider/set-shelf-poistion`,
            { productproviderid, shelfpositiondisplaynamekey, orderid }
        );
    }
}
